<!-- <section class="project">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 order-lg-1 order-md-2 order-sm-2 order-2">
        <div class="banner-content">
          <h1>D'NOUR</h1>
        </div>
      </div>
      <div class="col-lg-6 order-lg-2 order-md-1 order-sm-1 order-1">
        <div class="bannerimg">
          <img src="{{baseUrl}}/img/projects/dnour.jpg" alt="Design and web development agency">
        </div>
      </div>
      <div class="col-lg-3 order-lg-3 order-md-3 order-sm-3 order-3">
        <div class="banner-content">
          <p>
            End-to-end customer service.
            Snapcall is the easy way to
            chat live with an agent.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="brand-detail">
  <div class="container">
    <div class="row">
      <div class="col-xl-3 col-lg-3">
        <div class="d-xl-flex d-lg-flex d-block align-items-center justify-content-center">
          <div class="left-content">
            <div class="row">
              <div class="col-lg-12 col-md-4 col-sm-5 col-6">
                <h3>Services</h3>
                <p>Branding</p>
                <p>UX/UI Design</p>
                <p>Development</p>
              </div>
              <div class="col-lg-12 col-md-4 col-sm-5 col-6">
                <div class="startdate">
                  <h3>Date</h3>
                  <p>January 2020</p>
                </div>
                <hr class="d-xl-block d-lg-block d-none" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-7 col-lg-7">
        <div class="right-content">
          <h1>Hello I'm listening ...</h1>
          <p>Snapcall is the little green button that answers everything. All you need to do is place it at the bottom
            of a site's page in order to provide efficient and human-powered customer service. Easy to set up and quick
            to use, it connects users and agents by placing people at the heart of the customer service experience.</p>
          <p class="mb-0 mt-md-5 mt-sm-4 mt-3"><a href="https://dnour.com" target="_blank">D'NOUR <span
                class="barcelony">Online</span></a> </p>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="begins">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 offset-lg-3 col-md-8 offset-md-2">
        <h1>Careful from start to finish.</h1>
        <p>Our challenge was using the hyperlink as a creative starting point and letting our imagination free to
          incorporate the concept throughout the site. The design of Snapcall is based on the notion of exchange, a
          connection between two people, the transmission of words and advice, the flow of information sent and
          received. The green used signifies commitment, validation, and trust. Daring colors and a real-life aesthetic
          made the final proposal unique and lasting.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <div class="websketch">
          <img src="{{baseUrl}}/img/projects/website.jpg" alt="web designing agency">
        </div>
      </div>
    </div>
  </div>
</section>
<section>
  <div class="container">
    <div class="row">
      <div class="col-md-6 offset-md-3">
        <div class="match">
          <h1>Mix & Match.</h1>
          <p>Dare to create surprising mixtures by combining a shade of green with a sparkling blue and a bubbly yellow.
            Soften the visual concept by playing with rounded, elegant, and undulating patterns. Give character and
            presence to the content by using bold typography with square proportions. These were all bold challenges
            that our creative team was happy to take on.</p>
        </div>
      </div>
      <div class="col-md-12">
        <div class="colorpallates">
          <img src="{{baseUrl}}/img/projects/colorimg.jpg" alt="Brand agency">
        </div>
      </div>
    </div>
  </div>
</section>
 -->
<section id="project1" class="projects" data-scroll-nav="0">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
        <div class="row">
          <div class="col-xl-7 col-md-7 col-sm-6" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
            <div class="d-flex flex-column justify-content-center h-100 service-content">
              <div>
                <h1 class="heading">D'NOUR</h1>
                <div class="points">
                  <p>D'NOUR is a Dubai-based jewellery brand that places women at the forefront.</p>
                  <p> <a class="text-decoration-underline" href="http://www.dnour.com" target="_blank">dnour.com</a></p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-5 col-md-5 col-sm-6">
            <div class="d-flex flex-column justify-content-center align-items-sm-end">
              <div class="list-block">
                <h3 class="mt-0 mb-2" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100"><a href="{{Url}}/project-details/dnour#branding">Branding</a></h3>
                <h3 class="mt-0 mb-2" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="150"><a href="{{Url}}/project-details/dnour#animations">Animations</a></h3>
                <h3 class="mt-0 mb-2" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200"><a href="{{Url}}/project-details/dnour#ui-ux">UI/UX Design</a></h3>
                <h3 class="mt-0 mb-2" data-aos="fade-up" data-aos-duration="2500" data-aos-delay="250"><a href="{{Url}}/project-details/dnour#development">Development</a></h3>
                <h3 class="mt-0" data-aos="fade-up" data-aos-duration="3000" data-aos-delay="300"><a href="{{Url}}/project-details/dnour#seo">SEO</a></h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section data-scroll-nav="1" class="pb-0">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12 p-0"  data-aos="fade-up"  data-aos-duration="2000" data-aos-delay="100">
        <img src="{{baseUrl}}/images/projects/dnour/pages-banner.png" alt="Branding agency in Dubai " width="" height="" loading="lazy">
      </div>
    </div>
  </div>
</section>
<section class="section bg-black about-project" data-scroll-nav="2">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
        <div class="content">
          <p class="text-white">Pixtar, a leading web development agency, partnered with D'NOUR, a Dubai-based jewellery
            brand that stands as a beacon for women empowerment. D'NOUR's creations, inspired by the elegance of the
            Rose, embody powerful storytelling, exquisite craftsmanship, and a profound message of appreciation,
            empowerment, and celebration of women.</p>
          <p class="mb-0 text-white">Pixtar took on the challenge of establishing D'NOUR's online presence in the highly
            competitive E-commerce jewellery market, focusing specifically on the UAE and USA. The industry was
            saturated with top-notch brands, making organic SEO a complex undertaking for a newly designed and developed
            website.</p>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="bg-black branding" id="branding" data-scroll-nav="3">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
        <div class="row">
          <div class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
            <div class="content">
              <h1 class="text-white heading">Branding</h1>
              <p class="text-white">Pixtar crafted a distinctive logo, premium quality visiting cards, invoice covers,
                and other corporate branding materials. The visual identity aimed to reflect D'NOUR's commitment to
                celebrating and empowering women.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 p-0" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
        <div class="imglist mb-3">
          <img src="{{baseUrl}}/images/projects/dnour/dnour-project1.jpg" alt="best web design company in dubai" width="" height="" loading="lazy">
        </div>
      </div>
      <div class="col-xxl-10 col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 mx-lg-auto ps-md-0" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
            <img src="{{baseUrl}}/images/projects/dnour/bcard.png" alt="web designing agency dubai" width="" height="" loading="lazy">
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 ps-md-0" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
            <div class="list">
              <img src="{{baseUrl}}/images/projects/dnour/packaging.png" alt="Top branding agency in Dubai" width="" height="" loading="lazy" >
              <img src="{{baseUrl}}/images/projects/dnour/envelop.png" alt="website development company dubai" width="" height="" loading="lazy">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="bg-black story" data-scroll-nav="4">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
        <div class="row mb-4">
          <div class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10">
            <div class="content"  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
              <h1 class="text-white heading mb-2">Brand Story</h1>
              <p class="text-white">Branding is a strategic dance of logos, colors, and more, shaping a unique identity
                and perception in consumers' minds. It sets a brand apart, evoking emotions and building trust.</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
            <div class="video text-center">
              <!-- Copy & paste the video code here   autoplay="autoplay" loop="" allowfulscreen=""  controlslist="nodownload" -->
              <!-- <video class="customvideo w-100 h-auto" width="954" height="480" controls muted >
                <source src="https://dnour.com/pub/media/wysiwyg/about/the-brand-story-D'NOUR-DUBAI.mp4"
                  type="video/mp4">
                <source src="https://dnour.com/pub/media/wysiwyg/about/the-brand-story-D'NOUR-DUBAI.ogg&quot;"
                  type="video/ogg">
                Your browser does not support the video tag.
              </video> -->
              <video id="myVideo" class="customvideo w-100 h-auto" width="954" height="480" controls="controls" autoplay="true" muted="muted" loop="true" oncanplay="this.play()" onloadedmetadata="this.muted = true">
                <source src="https://dnour.com/pub/media/wysiwyg/about/the-brand-story-D'NOUR-DUBAI.mp4" type="video/mp4">
                <source src="https://dnour.com/pub/media/wysiwyg/about/the-brand-story-D'NOUR-DUBAI.ogg" type="video/ogg">
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          <div class="col-md-10 mx-md-auto">
            <div class="about-story">
              <h3 class="text-white semibold mt-0 subheading"  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">ABOUT WOMEN:</h3>
              <p class="text-white"  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="150">D'NOUR is fueled by the spectrum of emotions and the diverse stories that women
                carry with them.</p>
              <h3 class="text-white semibold mt-0 subheading"  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200">FOR WOMEN:</h3>
              <p class="text-white"  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="250">The vision, the jewellery, and the steps towards change - all crafted with women in
                mind, inspired by their strength and individuality.</p>
              <h3 class="text-white semibold mt-0 subheading"  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">TO WOMEN:</h3>
              <p class="text-white mb-0"  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="350">D'NOUR is committed to pushing the paradigm, empowering, celebrating, and giving
                back to women through their timeless and meaningful jewellery pieces.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="bg-black typography" data-scroll-nav="5">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto" >
        <div class="typography">
          <img src="{{baseUrl}}/images/projects/dnour/typography.png" alt="typography" width="" height="" loading="lazy"  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
          <p class="text-white"  data-aos="fade-up" data-aos-duration="2500" data-aos-delay="100">Pixtar curated a distinctive visual identity by meticulously choosing fonts and color
            combinations. The selected font reflected elegance and modernity, complementing D'NOUR's commitment to
            timeless beauty. The color palette incorporated soft rose hues, symbolizing the brand's inspiration, and
            gold accents, signifying luxury and sophistication.</p>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="bg-black package" data-scroll-nav="6">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
        <div class="row mb-4">
          <div class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10"  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
            <div class="content">
              <h1 class="text-white heading mb-2">Package Design</h1>
              <p class="text-white">Branding is a strategic dance of logos, colors, and more, shaping a unique identity
                and perception in consumers' minds. It sets a brand apart, evoking emotions and building trust.</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <img src="{{baseUrl}}/images/projects/dnour/packaging.png" alt="packaing2" width="" height="" loading="lazy" class="img1"  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
          </div>
          <div class="col-md-6">
            <img src="{{baseUrl}}/images/projects/dnour/box.png" alt="box" width="" height="" loading="lazy"  class="img2"  data-aos="fade-up" data-aos-duration="2500" data-aos-delay="150">
          </div>
          <div class="col-md-6">
            <img src="{{baseUrl}}/images/projects/dnour/package-envelop.png" alt="package-envelop" width="" height="" loading="lazy"  data-aos="fade-up" data-aos-duration="3000" data-aos-delay="200">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="animation" id="animations" data-scroll-nav="7">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto"  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
        <div class="row mb-4">
          <div class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10">
            <div class="content">
              <h1 class="heading">Animations</h1>
              <p class="">Branding is a strategic dance of logos, colors, and more, shaping a unique identity and
                perception in consumers' minds. It sets a brand apart, evoking emotions and building trust.</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12"  data-aos="fade-up" data-aos-duration="2500" data-aos-delay="100">
            <!-- <img src="{{baseUrl}}/images/projects/dnour/animation.png" alt="Top branding agency in Dubai" width="" height=""> -->
            <video class="w-100 h-auto" id="myVideo" width="320" height="176" controls="controls" autoplay="true" muted="muted" loop="true" oncanplay="this.play()" onloadedmetadata="this.muted = true">
              <source src="{{baseUrl}}/images/projects/dnour/dnour-brand-logo-animation.mp4" type="video/mp4">
              <source src="{{baseUrl}}/images/projects/dnour/dnour-brand-logo-animation.ogg" type="video/ogg">
              Your browser does not support HTML5 video.
            </video>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
<section class="ui-ux" id="ui-ux" data-scroll-nav="8">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
        <div class="row mb-4">
          <div class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10"  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
            <div class="content">
              <h1 class="heading mb-2">UI/UX Design</h1>
              <p class="">Created an engaging and user-centric interface for the D'NOUR website, ensuring a seamless and
                visually appealing user experience that resonated with the brand's ethos.</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-9 mx-lg-auto"  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">

            <video class="w-100 h-auto desktopimg" id="myVideo2" width="320" height="176" autoplay="true" muted="muted" loop="true" oncanplay="this.play()" onloadedmetadata="this.muted = true">
              <source src="{{baseUrl}}/images/projects/dnour/dnour-desktop-imac-scroll.mp4" type="video/mp4">
              <source src="{{baseUrl}}/images/projects/dnour/dnour-desktop-imac-scroll.ogg" type="video/ogg">
              Your browser does not support HTML5 video.
            </video>
            <!-- <img src="{{baseUrl}}/images/projects/dnour/dnour-desktop.png" alt="website developers in dubai" width="" height="" class="desktopimg"> -->
            
            <!-- <img src="{{baseUrl}}/images/projects/dnour/dnour-laptop.png" alt="web development company dubai" width="" height=""> -->
            <video class="w-100 h-auto" id="myVideo3" width="320" height="176" autoplay="true" muted="muted" loop="true" oncanplay="this.play()" onloadedmetadata="this.muted = true">
              <source src="{{baseUrl}}/images/projects/dnour/laptop-scroll.mp4" type="video/mp4">
              <source src="{{baseUrl}}/images/projects/dnour/laptop-scroll.ogg" type="video/ogg">
              Your browser does not support HTML5 video.
            </video>
            
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
<section class="development" id="development" data-scroll-nav="9">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
        <div class="row mb-4">
          <div class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10"  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
            <div class="content">
              <h1 class="heading mb-2">Development</h1>
              <p class="">Developed the website using Magento, incorporating advanced features to showcase D'NOUR's
                exquisite jewellery collections. Security measures were implemented to safeguard user data and
                transactions.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 p-0"  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
    <!-- <img src="{{baseUrl}}/images/projects/dnour/development.jpg" alt="web development dubai" width="" height=""> -->
    <video class="w-100 h-auto" id="myVideo2" width="320" height="176" autoplay="true" muted="muted" loop="true" oncanplay="this.play()" onloadedmetadata="this.muted = true">
      <source src="{{baseUrl}}/images/projects/dnour/homescreen.mp4" type="video/mp4">
      <source src="{{baseUrl}}/images/projects/dnour/homescreen.ogg" type="video/ogg">
      Your browser does not support HTML5 video.
    </video>
    <div class="owlcarousel1"  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
      <owl-carousel-o [options]="desktopslider">
        <ng-container *ngFor="let slide of imageData">
          <ng-template class="slide" carouselSlide [id]="slide.id" *ngIf="slide.id<=3">
            <img [src]="slide.url" [alt]="" [title]="" width="" height="" loading="lazy">
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
    <div class="owlcarousel2"  data-aos="fade-up" data-aos-duration="2500" data-aos-delay="150">
      <owl-carousel-o [options]="desktopslider1">
        <ng-container *ngFor="let slide of imageData">
          <ng-template class="slide" carouselSlide [id]="slide.id" *ngIf="slide.id>=4 && slide.id<=6">
            <img [src]="slide.url" [alt]="" [title]="" width="" height="" loading="lazy">
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
    <div class="owlcarousel3">
      <owl-carousel-o [options]="desktopslider2"  data-aos="fade-up" data-aos-duration="3000" data-aos-delay="200">
        <ng-container *ngFor="let slide of imageData">
          <ng-template class="slide" carouselSlide [id]="slide.id" *ngIf="slide.id>=7 && slide.id<=9    ">
            <img [src]="slide.url" [alt]="" [title]="" width="" height="" loading="lazy">
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
  </div>
</section>
<section class="seo-section" id="seo" data-scroll-nav="10">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xxl-9 col-xl-10 col-lg-11 col-md-11 col-sm-11 col-11 mx-auto">
        <div class="row mb-4">
          <div class="col-xxl-5 col-xl-6 col-lg-8 col-md-10 col-sm-10"  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
            <div class="content">
              <h1 class="heading">SEO</h1>
              <p class="">Formulated a targeted organic SEO strategy tailored to the unique challenges of the E-commerce
                jewellery industry. Focused on optimizing the website for local search in the UAE and USA, leveraging
                keywords that aligned with D'NOUR's brand identity and unique selling propositions.</p>

            </div>
          </div>
        </div>
        <!-- <img class="seo" src="{{baseUrl}}/images/projects/dnour/seo.png" alt="graphic design company" width="" height=""  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100"> -->
        <video class="w-100 h-auto seo" id="myVideo1" width="320" height="176" autoplay="true" muted="muted" loop="true" oncanplay="this.play()" onloadedmetadata="this.muted = true">
          <source src="{{baseUrl}}/images/projects/dnour/dnour-seo.mp4" type="video/mp4">
          <source src="{{baseUrl}}/images/projects/dnour/dnour-seo.ogg" type="video/ogg">
          Your browser does not support HTML5 video.
        </video>
        <p>Pixtar's holistic approach, encompassing branding, design, development, and a targeted organic SEO strategy,
          yielded positive outcomes. D'NOUR's online presence in the UAE and USA flourished, gaining visibility among
          its target audience despite the formidable competition. The case study serves as a testament to Pixtar's
          expertise in navigating challenges and helping a brand like D'NOUR shine in a crowded digital landscape.</p>
      </div>
    </div>
  </div>
</section>
<section class="next bg-black pb-0"  data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="next-block">
          <div class="in-line">
            <a href="{{Url}}/project-details/pakhis" class="text-white font-bold border-radius-25">
            <img src="{{baseUrl}}/images/projects/pakhis/pixtar-next.png" alt="Best Web Designers in Dubai" width="280"
              height="280" loading="lazy">
            <h1 class="heading text-white">NEXT
                  PROJECT</h1>
                </a>
            <!-- (click)="$event.preventDefault()  -->
          </div>
        </div>
      </div>
    </div>
    <div class="line"></div>
  </div>
</section>